// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-mobile {
  padding: 0 1rem;
}
.filter-mobile__button {
  width: 100%;
  padding: 0.5rem 1rem !important;
  border: 1px solid rgba(var(--grey-800));
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;
  gap: 0.5rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-filter-list,
.menu-filter-item {
  box-sizing: border-box;
  position: fixed;
  z-index: 999999;
  top: 0;
  bottom: 0;
  left: -100%;
  background-color: rgba(var(--white));
  transition: all 0.5s;
  width: 100%;
  padding: 2rem 1.5rem;
}
.menu-filter-list_open,
.menu-filter-item_open {
  left: 0;
}
.menu-filter-list__icons,
.menu-filter-item__icons {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.menu-filter-list__close,
.menu-filter-item__close {
  margin-left: 1.5rem;
}
.menu-filter-list__clear,
.menu-filter-item__clear {
  margin-right: 1.5rem;
}
.menu-filter-list__content,
.menu-filter-item__content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 1.5rem;
}
.menu-filter-list-wrapper,
.menu-filter-item-wrapper {
  background-color: rgba(var(--white));
  padding: 1rem 1.5rem 2rem;
}
.menu-filter-list-item,
.menu-filter-item-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.25rem 0;
}
.menu-filter-list-item-wrapper,
.menu-filter-item-item-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.menu-filter-list-item__label,
.menu-filter-item-item__label {
  color: rgba(var(--grey-800));
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 600;
}
.menu-filter-list-item__action,
.menu-filter-item-item__action {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.menu-filter-list-item__tabs,
.menu-filter-item-item__tabs {
  display: flex;
  gap: 0.5rem;
  padding: 0 1.5rem;
  position: relative;
  overflow-x: auto;
}

.menu-filter-list {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2rem 0;
}
.menu-filter-list-item {
  margin: 0 1.5rem;
}
.menu-filter-list__content {
  overflow: auto;
  position: relative;
  height: calc(100svh - 165px);
}`, "",{"version":3,"sources":["webpack://./src/components/FilterMobile/styles.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AACE;EACE,WAAA;EACA,+BAAA;EACA,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;;AAGA;;EAEE,sBAAA;EACA,eAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,oCAAA;EACA,oBAAA;EACA,WAAA;EACA,oBAAA;AAAF;AAEE;;EACE,OAAA;AACJ;AAEE;;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACJ;AAEE;;EACE,mBAAA;AACJ;AAEE;;EACE,oBAAA;AACJ;AAEE;;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;AACJ;AAEE;;EACE,oCAAA;EACA,yBAAA;AACJ;AAEE;;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AACJ;AACI;;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAEN;AACI;;EACE,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAEN;AACI;;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAEN;AACI;;EACE,aAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAEN;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,eAAA;AAAF;AAEE;EACE,gBAAA;AAAJ;AAGE;EACE,cAAA;EACA,kBAAA;EACA,4BAAA;AADJ","sourcesContent":[".filter-mobile {\n  padding: 0 1rem;\n\n  &__button {\n    width: 100%;\n    padding: 0.5rem 1rem !important;\n    border: 1px solid rgba(var(--grey-800));\n    border-radius: 4px;\n    font-size: 1rem;\n    font-weight: 500;\n    line-height: 1.5rem;\n    gap: 0.5rem;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.menu-filter-list,\n.menu-filter-item {\n  box-sizing: border-box;\n  position: fixed;\n  z-index: 999999;\n  top: 0;\n  bottom: 0;\n  left: -100%;\n  background-color: rgba(var(--white));\n  transition: all 0.5s;\n  width: 100%;\n  padding: 2rem 1.5rem;\n\n  &_open {\n    left: 0;\n  }\n\n  &__icons {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  &__close {\n    margin-left: 1.5rem;\n  }\n\n  &__clear {\n    margin-right: 1.5rem;\n  }\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    margin-top: 1.5rem;\n  }\n\n  &-wrapper {\n    background-color: rgba(var(--white));\n    padding: 1rem 1.5rem 2rem;\n  }\n\n  &-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.25rem 0;\n\n    &-wrapper {\n      display: flex;\n      flex-direction: column;\n      gap: 1rem;\n    }\n\n    &__label {\n      color: rgba(var(--grey-800));\n      font-size: 1rem;\n      line-height: 1.5;\n      font-weight: 600;\n    }\n\n    &__action {\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n    }\n\n    &__tabs {\n      display: flex;\n      gap: 0.5rem;\n      padding: 0 1.5rem;\n      position: relative;\n      overflow-x: auto;\n    }\n  }\n}\n\n.menu-filter-list {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 2rem 0;\n\n  &-item {\n    margin: 0 1.5rem;\n  }\n\n  &__content {\n    overflow: auto;\n    position: relative;\n    height: calc(100svh - 165px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
